import styled from 'styled-components';

export const ViewerContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: inherit;
  scrollbar-width: thin;
  scrollbar-color: #0000001f transparent;
  overflow-x: hidden;
`;

export const ContainerPagesDocument = styled.div`
  width: inherit;
  height: 100%;
  overflow: hidden;
  scrollbar-width: thin;
  scrollbar-color: #0000001f transparent;
  overflow: auto;

  &[data-show-single-page='true'] {
    overflow: hidden;
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10;
`;

export const ShowSinglePageCanvas = styled.canvas`
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
`;

export const MultiPagesCanvas = styled.canvas`
  display: block;
  height: 100%;
  margin: 8px auto;
`;
